import React, { memo } from "react";
import Accordion from "react-bootstrap/Accordion";
import LazyLoad from "react-lazyload";
import Button from "../Common/Button";
import Input from "../Common/Input";
import MenuComponent from "../Common/Menu";
import RenderLatexContent from "../RenderLatexContent";
import { useNavigate } from "react-router-dom";
import {
  isDeleteOwnAccess,
  isEditOwnAccess,
} from "../../utils/permissionsParser";

function AccordionComponent({
  header,
  subHeader,
  button,
  buttonText,
  btnClick,
  btnImage,
  questionsMenuList,
  showCheckboxes = null,
  children,
  index,
  className,
  handleQuestionSelect,
  selectedQuestions,
  item,
  alwaysOpen = false, // New prop to control if the accordion should always be open
  handleDeleteSection, // New prop to handle section deletion
  sections = [],
  permissions,
  userId,
  createdBy,
}) {
  const navigate = useNavigate();
  const renderCheckboxes = () => {
    if (showCheckboxes) {
      return (
        <Input
          type="checkbox"
          style={{ marginRight: "8px" }}
          checked={selectedQuestions.includes(item?._id)}
          onChange={() => handleQuestionSelect(item?._id)}
        />
      );
    }
    return null;
  };

  const renderButton = () => (
    <Button
      onClick={() => btnClick(item)}
      style={{
        background: "transparent",
        color: "#4403bf",
        border: "#4403bf 1px solid",
        marginLeft: "auto",
        fontSize: "12px",
      }}
      className={`${
        buttonText !== null
          ? "mx-3 px-3 py-1 d-flex align-items-center"
          : "mx-2 py-1 px-1 d-flex align-items-center"
      }`}
    >
      <LazyLoad height={20} offset={100}>
        <img
          style={{ width: "16px" }}
          src={btnImage}
          alt={`${btnImage}-icon`}
          className={buttonText !== null ? "mx-2" : null}
        />
      </LazyLoad>
      <strong>{buttonText}</strong>
    </Button>
  );

  const renderMenuButton = () => (
    <MenuComponent list={questionsMenuList} passedData={item}>
      {renderButton()}
    </MenuComponent>
  );

  const renderDeleteButton = () => (
    <>
      {(permissions?.edit ||
        isEditOwnAccess(permissions, userId, createdBy)) && (
        <Button
          onClick={() => {
            navigate(
              `create-section?sections=${sections?.length}&sectionId=${item?._id}`
            );
          }} // Trigger delete section function
          style={{
            background: "transparent",
            color: "red",
            border: "none",
            fontSize: "12px",
          }}
          className="mx-2 py-1 px-1 d-flex align-items-center"
        >
          <LazyLoad height={20} offset={100}>
            <img
              style={{ width: "16px" }}
              src="/editIcon.svg"
              alt="delete-icon"
            />
          </LazyLoad>
        </Button>
      )}
      {(permissions?.delete ||
        isDeleteOwnAccess(permissions, userId, createdBy)) && (
        <Button
          onClick={() => handleDeleteSection(item?._id)} // Trigger delete section function
          style={{
            background: "transparent",
            color: "red",
            border: "none",
            fontSize: "12px",
          }}
          className="mx-2 py-1 px-1 d-flex align-items-center"
        >
          <LazyLoad height={20} offset={100}>
            <img
              style={{ width: "16px" }}
              src="/deleteIcon.svg"
              alt="delete-icon"
            />
          </LazyLoad>
        </Button>
      )}
    </>
  );

  return (
    <Accordion
      defaultActiveKey={alwaysOpen ? index : null} // Use `index` if `alwaysOpen` is true
      activeKey={alwaysOpen ? index : undefined} // Set `activeKey` based on `alwaysOpen`
      className={className}
    >
      <Accordion.Item eventKey={index} className="w-100">
        <Accordion.Header>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className="d-flex align-items-center">
              {renderCheckboxes()}
              {/* <FormattedText text={header} maxLength={200} /> */}
              <RenderLatexContent content={header} />

              {subHeader && (
                <span
                  className="mx-3 px-2 py-1"
                  style={{
                    background: "#8B97A833",
                    color: "#8B97A8",
                    border: "1px solid #8B97A833",
                    borderRadius: "4px",
                  }}
                >
                  {subHeader}
                </span>
              )}
            </div>
            <div className="d-flex align-items-center">
              {button &&
                (questionsMenuList ? renderMenuButton() : renderButton())}
              {renderDeleteButton()} {/* Add delete button */}
            </div>
          </div>
        </Accordion.Header>
        <Accordion.Body className="p-0">{children}</Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

export default memo(AccordionComponent);
